import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

const WishlistEager = lazy(
  () =>
    import('./WishlistPage.eager').then(mod => ({
      default: mod.WishlistPageEager,
    })),
  {
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

export const WishlistPage = () => {
  return <WishlistEager />;
};
